module.exports = __webpack_public_path__ + "static/img/ridneslovobird.706943a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ridneslovobird.png
// module id = 593
// module chunks = 1